/**
 * Whether the agency is a solo-broker account (not a multi-member real-estate agency).
 * @param type - Agency type from the API (`agency` | `solo_broker`).
 * @returns True when broker-assignment UI should be hidden.
 */
export function isSoloBrokerAgency(type?: string | null): boolean {
  return type === 'solo_broker';
}
